import React from "react";
import { AtSign, ExternalLink, HelpCircle, Command, Mic, BookOpen, MessageCircle, MessageSquare } from "react-feather";
import type { KeyChord } from "../../../services/commands/commands.types";
import { HelpMenu } from "../../molecules/HelpMenu";
import type { HelpMenuItem } from "../../molecules/HelpMenu";
import { HELP_MENU_COPY as COPY } from "./HelpMenuHost.copy";
import { Popover, Trigger, Wrapper } from "./HelpMenuHost.styles";
import { useHelpMenuHostInternalState } from "./useHelpMenuHostInternalState";

/** Voice chord (Shift+Mod+V), as bound app-wide. Mod+M minimises the window on Mac. */
const VOICE_CHORD: KeyChord = { key: "v", mod: true, shift: true };

/** The top bar's help button and its menu. */
export const HelpMenuHost: React.FC = () => {
  const state = useHelpMenuHostInternalState();
  const items: HelpMenuItem[] = [
    { id: "shortcuts", label: COPY.shortcuts, icon: <Command size={13} />, chords: [{ key: "?" }] },
    { id: "voice", label: COPY.voice, icon: <Mic size={13} />, iconTone: "accent", chords: [VOICE_CHORD], disabledReason: state.voiceDisabledReason },
    state.whatsNewUrl
      ? { id: "whats-new", label: COPY.whatsNew, icon: <ExternalLink size={13} />, href: state.whatsNewUrl }
      : // PENDING: PENDING-HELP-LINKS (no What's new URL configured: REACT_APP_WHATS_NEW_URL)
        { id: "whats-new", label: COPY.whatsNew, icon: <ExternalLink size={13} />, soon: true },
    state.docsUrl
      ? { id: "docs", label: COPY.docs, icon: <BookOpen size={13} />, href: state.docsUrl }
      : // PENDING: PENDING-HELP-LINKS (no Docs URL configured: REACT_APP_DOCS_URL)
        { id: "docs", label: COPY.docs, icon: <BookOpen size={13} />, soon: true },
    state.liveChatAvailable
      ? { id: "live-chat", label: COPY.liveChat, icon: <MessageCircle size={13} /> }
      : { id: "live-chat", label: COPY.liveChat, icon: <MessageCircle size={13} />, soon: true },
    { id: "feedback", label: COPY.feedback, icon: <MessageSquare size={13} /> },
    state.supportUrl
      ? { id: "support", label: COPY.support, icon: <AtSign size={13} />, href: state.supportUrl }
      : // PENDING: PENDING-SUPPORT-LINK (no support destination configured)
        { id: "support", label: COPY.support, icon: <AtSign size={13} />, soon: true },
  ];
  return (
    <Wrapper ref={state.wrapperRef}>
      <Trigger
        type="button"
        $open={state.open}
        aria-label={COPY.trigger}
        aria-haspopup="menu"
        aria-expanded={state.open}
        onClick={state.toggle}
      >
        <HelpCircle size={18} aria-hidden="true" />
      </Trigger>
      {state.open ? (
        <Popover>
          <HelpMenu items={items} label={COPY.menu} soonLabel={COPY.soon} onSelect={state.onSelect} />
        </Popover>
      ) : null}
    </Wrapper>
  );
};

export default HelpMenuHost;
